var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9767 183.333H177.024C195.568 183.333 206.446 160.78 195.829 144.343L120.998 28.5012C110.805 12.721 89.1955 12.721 79.0011 28.5012L4.17015 144.343C-6.44543 160.78 4.4326 183.333 22.9767 183.333Z",
    fill: "#FF737D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 124.238C93.0008 124.238 87.2742 118.511 87.2742 111.512V60.4481C87.2742 53.4473 93.0008 47.7207 100 47.7207C106.999 47.7207 112.726 53.4473 112.726 60.4481V111.512C112.726 118.511 106.999 124.238 100 124.238Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.566 148.454C112.566 155.394 106.94 161.018 100.001 161.018C93.0608 161.018 87.4349 155.394 87.4349 148.454C87.4349 141.515 93.0608 135.889 100.001 135.889C106.94 135.889 112.566 141.515 112.566 148.454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.bfe3a8ff52e3ad0cb86969a52f9f910f.svg";
export { ForwardRef as ReactComponent };